/** After a deploy, an open tab may ask for page files that no longer exist: reload once to get the new ones. */
export function isChunkError(err: unknown): boolean {
  const text = err instanceof Error ? `${err.name} ${err.message}` : String(err);
  return /dynamically imported module|Importing a module script failed|error loading dynamically|ChunkLoadError|Failed to fetch/i.test(text);
}

/**
 * A broken page tells the server, as large apps' crash reporting does, so it is seen without anyone having to
 * report it: the path without its query or fragment and the error's own message, never what was typed.
 */
export function reportCrash(err: unknown) {
  if (!navigator.onLine || isChunkError(err)) return;
  const e = err instanceof Error ? err : new Error(String(err));
  const report = {
    path: location.pathname,
    message: `${e.name}: ${e.message}`.slice(0, 500),
    stack: (e.stack ?? '').split('\n').slice(0, 12).join('\n').slice(0, 2000),
    release: document.querySelector<HTMLScriptElement>('script[type="module"][src*="/assets/"]')?.src.split('/').pop() ?? '',
  };
  try {
    const body = new Blob([JSON.stringify(report)], { type: 'application/json' });
    if (!navigator.sendBeacon?.('/api/v1/client-errors', body)) {
      void fetch('/api/v1/client-errors', { method: 'POST', body, keepalive: true, credentials: 'same-origin' }).catch(() => undefined);
    }
  } catch {
    /* reporting must never break the error screen */
  }
}
